import get from "lodash/get";

/* @ngInject */
function currencyFormatter(currencies, $rootScope) {
  return function (number = 0, currencyCode, onlyNumber = false) {
    if (!currencyCode) currencyCode = get($rootScope.organization, "settings.currency", "EUR");

    if (!number) {
      number = 0;
    }

    const currencyObject = currencies.find((currencyObject) => currencyObject.code === currencyCode);

    let numberFormatted = new Intl.NumberFormat(currencyObject.language, {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "code",
    })
      .format(number)
      .replace(currencyObject.code, onlyNumber ? "" : currencyObject.symbol);

    if (numberFormatted[0] === "-") {
      numberFormatted = numberFormatted.replace("-" + currencyObject.symbol, currencyObject.symbol + "-");
    }

    return numberFormatted;
  };
}

export default currencyFormatter;
